import { createAsyncThunk } from '@reduxjs/toolkit';
import { getIdentityInformation } from 'src/app/api/identity';
import { showMessage } from '../core/messageSlice';

export const loadIdentityCustoms = createAsyncThunk(
  'identitySlice',
  async (empty, { dispatch, getState, rejectWithValue }) => {
    try {
      // const { identity } = getState();
      const response = await getIdentityInformation();
      const { data } = response;
      return { custom: data };
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.response?.data?.messages?.[0] || 'Unknown error';
      dispatch(
        showMessage({
          message: `Error: ${errorMessage}`,
        })
      );
      return rejectWithValue(errorMessage);
    }
  }
);
